<div class="auth-wrapper auth-v2">
  <!-- Brand logo (HORS de la .row) -->
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
    <h2 class="brand-text text-primary ml-1">{{ '' | enterpriseName }}</h2>
  </a>
  <!-- /Brand logo -->

  <div class="auth-inner row m-0">
    <!-- Left Image -->
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/login-v2-dark.svg'
              : 'assets/images/pages/login-v2.svg'
          "
          alt="Register V2"
        />
      </div>
    </div>

    <!-- Register Form -->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">Créer un compte</h2>
        <p class="card-text mb-2">Inscrivez-vous et commencez votre expérience.</p>

        
          <div class="form-group">
            <label class="form-label" for="register-first-name">Prénom</label>
            <input
              type="text"
              id="register-first-name"
              class="form-control"
              placeholder="Votre prénom"
              tabindex="1"
              [(ngModel)]="data.prenom"
              [class.border-red]="dataError.prenom && dataError.prenom.length > 0"
              required
            />
             
                  <div class="alert-body red" *ngIf="dataError.prenom && dataError.prenom.length>0">
                       <p>{{dataError.prenom}}</p>
                    
                  </div>
          
          </div>
          

          <div class="form-group">
            <label class="form-label" for="register-last-name">Nom</label>
            <input
              type="text"
              id="register-last-name"
              class="form-control"
              placeholder="Votre nom"
              tabindex="2"
                [(ngModel)]="data.nom"
                [class.border-red]="dataError.nom && dataError.nom.length > 0"
              required
            />
            <div class="alert-body red" *ngIf="dataError.nom && dataError.nom.length>0">
                       <p>{{dataError.nom}}</p>
                    
                  </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="register-email">Email</label>
            <input
              type="email"
              id="register-email"
              class="form-control"
              placeholder="anis@example.com"
              tabindex="3"
                [(ngModel)]="data.email"
                [class.border-red]="dataError.email && dataError.email.length > 0"
              required
            />
            <div class="alert-body red" *ngIf="dataError.email && dataError.email.length>0">
                       <p>{{dataError.email}}</p>
                    
                  </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="register-password">Mot de passe</label>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                type="{{displayPassword}}"
                id="register-password"
                class="form-control form-control-merge"
                placeholder="············"
                tabindex="4"
                [(ngModel)]="data.password"
                [class.border-red]="dataError.password && dataError.password.length > 0"
                required
              />
              <div class="input-group-append" >
                <span class="input-group-text cursor-pointer" (click)="changeDisplay()" [class.border-red]="dataError.password && dataError.password.length > 0">
                   <i
                    class="feather"
                    [ngClass]="displayPassword === 'password' ? 'icon-eye' : 'icon-eye-off'"
                    
                  ></i>
                </span>
              </div>
             
            </div>
             <div class="alert-body red" *ngIf="dataError.password && dataError.password.length>0">
                       <p>{{dataError.password}}</p>
                    
             </div>
          </div>

        
          <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" (click)="compte()" rippleEffect>
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Créer mon compte
          </button>

          <div class="alert-body red mt-1" *ngIf="errorMessage">
            <p>{{ errorMessage }}</p>
          </div>


        <p class="text-center mt-2">
          <span>Déjà inscrit ?</span>
          <a routerLink="/login">
            <span>&nbsp;Se connecter</span>
          </a>
        </p> 

        <div class="divider my-2">
          <div class="divider-text">ou</div>
        </div>

        <div class="auth-footer-btn d-flex justify-content-center">
          <a class="btn btn-facebook" href="#"><i data-feather="facebook"></i></a>
          <a class="btn btn-twitter white" href="#"><i data-feather="twitter"></i></a>
          <a class="btn btn-google" href="#"><i data-feather="mail"></i></a>
          <a class="btn btn-github" href="#"><i data-feather="github"></i></a>
        </div>
      </div>
    </div>
    <!-- /Register Form -->
  </div>
</div>
